import { createLevelContext } from "../_lib/createLevelContext";

const { Provider, useValue } = createLevelContext("second");

export const SecondLevelProvider = Provider;
export const useSecondLevelContext = useValue;
